import React from 'react';
import { Input, Space, Typography } from 'antd';
import { COUNTRY_TABS } from './monetizationTabState';
import type { PageTab } from './monetizationTabState';

const { Text } = Typography;

/** Beside the country box on Banners & Offers: the offer cards have no country. */
export const COUNTRY_FUNNELS_NOTE = 'Country applies to the popup funnel only';

interface Props {
  tab: PageTab;
  value: string | undefined;
  onSearch(country: string | undefined): void;
}

/** The country box, on the tabs it applies to; Banners & Offers adds a note on what it filters. */
export const CountryFilter: React.FC<Props> = ({ tab, value, onSearch }) => {
  if (!COUNTRY_TABS.includes(tab)) return null;
  return (
    <Space size={8} align="center">
      <Input.Search
        aria-label="Country"
        allowClear
        style={{ width: 220 }}
        placeholder="Country (e.g. India)"
        defaultValue={value}
        onSearch={(v) => onSearch(v.trim() || undefined)}
      />
      {tab === 'funnels' && (
        <Text type="secondary" style={{ fontSize: 12 }} data-note="country-popup-only">
          {COUNTRY_FUNNELS_NOTE}
        </Text>
      )}
    </Space>
  );
};
